import { Api } from '../services/Api';

let prevAttributes = null;

// configurations for change path based on component
const componentPathMap = {
  NotificationsModal: '/notifications',
};

const Apm = {
  registerInteraction: async (attributes) => {
    if (prevAttributes) {
      const areEqual = JSON.stringify(attributes) === JSON.stringify(prevAttributes);
      if (areEqual) {
        console.log('Atributos idénticos a los anteriores, no se registrará la actividad');
        return;
      }
    }

    prevAttributes = [...attributes];

    // change path based on component
    const modifiedAttributes = attributes.map(attr => {
      if (attr.key === 'path') {
        const componentAttr = attributes.find(a => a.key === 'component');
        if (componentAttr && componentPathMap[componentAttr.value]) {
          return { ...attr, value: componentPathMap[componentAttr.value] };
        }
      }
      return attr;
    });

    if (newrelic) {
      modifiedAttributes.forEach(attribute => {
        newrelic.interaction().setAttribute(attribute.key, attribute.value);
        newrelic.interaction().save();
      });
    }
    try {
      const userActivity = Object.fromEntries(modifiedAttributes.map(attr => [attr.key, attr.value]));
      await Api.post('/dashboard_user_activity', {
        user_activity: userActivity
      });
    } catch (error) {
      console.error('Track error:', error);
    }
  },
  noticeError: (attributes, error) => {
    if (newrelic) {
      newrelic.noticeError(error, { errorMessage: attributes.message });
    }
  }
}

export default Apm;
